const BN = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

export const bn = (v: string | number | null | undefined) => String(v ?? "").replace(/\d/g, (d) => BN[+d]);
export const money = (n: number) => {
  const v = Number(n) || 0;
  const hasFrac = Math.round(v * 100) % 100 !== 0;
  return bn(v.toLocaleString("en-IN", { minimumFractionDigits: hasFrac ? 2 : 0, maximumFractionDigits: 2 }));
};
export const tk = (n: number) => `৳ ${money(n)}`;
export const fmtDate = (s?: string | null) => (s ? bn(s.split("-").reverse().join("/")) : "—");
export const todayStr = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Dhaka" });
export const fmtTime = (iso?: string) =>
  iso ? bn(new Date(iso).toLocaleTimeString("en-US", { timeZone: "Asia/Dhaka", hour: "2-digit", minute: "2-digit" })) : "";

const W = (
  "শূন্য এক দুই তিন চার পাঁচ ছয় সাত আট নয় দশ এগারো বারো তেরো চৌদ্দ পনেরো ষোল সতেরো আঠারো উনিশ " +
  "বিশ একুশ বাইশ তেইশ চব্বিশ পঁচিশ ছাব্বিশ সাতাশ আটাশ ঊনত্রিশ ত্রিশ একত্রিশ বত্রিশ তেত্রিশ চৌত্রিশ পঁয়ত্রিশ ছত্রিশ সাঁইত্রিশ আটত্রিশ ঊনচল্লিশ " +
  "চল্লিশ একচল্লিশ বিয়াল্লিশ তেতাল্লিশ চুয়াল্লিশ পঁয়তাল্লিশ ছেচল্লিশ সাতচল্লিশ আটচল্লিশ ঊনপঞ্চাশ পঞ্চাশ একান্ন বাহান্ন তিপ্পান্ন চুয়ান্ন পঞ্চান্ন ছাপ্পান্ন সাতান্ন আটান্ন ঊনষাট " +
  "ষাট একষট্টি বাষট্টি তেষট্টি চৌষট্টি পঁয়ষট্টি ছেষট্টি সাতষট্টি আটষট্টি ঊনসত্তর সত্তর একাত্তর বাহাত্তর তিয়াত্তর চুয়াত্তর পঁচাত্তর ছিয়াত্তর সাতাত্তর আটাত্তর ঊনআশি " +
  "আশি একাশি বিরাশি তিরাশি চুরাশি পঁচাশি ছিয়াশি সাতাশি আটাশি ঊননব্বই নব্বই একানব্বই বিরানব্বই তিরানব্বই চুরানব্বই পঁচানব্বই ছিয়ানব্বই সাতানব্বই আটানব্বই নিরানব্বই"
).split(" ");

function words(n: number): string {
  if (n === 0) return W[0];
  const parts: string[] = [];
  const crore = Math.floor(n / 10000000);
  n %= 10000000;
  if (crore) parts.push(`${words(crore)} কোটি`);
  const steps: [number, string][] = [[100000, "লক্ষ"], [1000, "হাজার"], [100, "শত"]];
  for (const [d, label] of steps) {
    const q = Math.floor(n / d);
    n %= d;
    if (q) parts.push(`${W[q]} ${label}`);
  }
  if (n) parts.push(W[n]);
  return parts.join(" ");
}

export function amountInWords(amount: number) {
  const a = Math.max(0, Number(amount) || 0);
  const t = Math.floor(a);
  const p = Math.round((a - t) * 100);
  return `${words(t)} টাকা${p ? ` ${words(p)} পয়সা` : ""} মাত্র`;
}

// ধাপে ধাপে শতকরা ছাড় (যেমন "10+2+2") — ভিত্তি দরের উপর ক্রমান্বয়ে প্রয়োগ
export const parsePercents = (s?: string) =>
  (String(s ?? "").match(/\d+(\.\d+)?/g) || []).map(Number).filter((n) => n > 0 && n < 100);
export const netRate = (base: number | string, disc?: string) => {
  let r = +base || 0;
  for (const p of parsePercents(disc)) r = r * (1 - p / 100);
  return r;
};

export const SHOP = {
  name: "রানা ইলেক্ট্রিক",
  nameEn: "RANA ELECTRIC",
  address: "কেল্লাবন্দ সিটি মারকেট, সিও বাজার, রংপুর",
  proprietor: "মো রানা মোল্লা",
  mobile: "+8801738439571",
};

export const CATEGORIES = ["তার / ক্যাবল", "লাইট / বাল্ব", "সুইচ / সকেট", "ফ্যান", "ব্রেকার / ফিউজ", "বোর্ড / প্যানেল", "পাইপ / ফিটিংস", "অন্যান্য"];
export const UNITS = ["পিস", "মিটার", "গজ", "কয়েল", "রোল", "প্যাকেট", "বক্স", "সেট", "কেজি", "ফুট"];
export const PAY_METHODS = ["নগদ", "বিকাশ", "নগদ (অ্যাপ)", "রকেট", "ব্যাংক"];
export const EXPENSE_CATEGORIES = ["দোকান ভাড়া", "বিদ্যুৎ বিল", "কর্মচারী বেতন", "যাতায়াত / পরিবহন", "চা / খাবার", "মেরামত", "অন্যান্য"];
